import PHPURL from '../reducers/ReducerPHPURL';

export function getTypes() {

    let phpPath = PHPURL.baseURL + PHPURL.getTypes;

    return function(dispatch) {

        fetch(phpPath)
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "TYPES",
                    payload: data.Types
                })
            })
            .catch((error) => {
                dispatch({
                    type: "TYPES",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/getTypes.js